module.exports = __webpack_public_path__ + "static/media/IMG_0081.18200aa2.jpg";